import React from 'react'

const Dsw16 = () => {
    return (
        <div className='container'>
            
        <div class="tabs">
           <input type="radio" name="tab" id="tab1" />
           <label for="tab1">CPP</label>
           <input type="radio" name="tab" id="tab2"/>
           <label for="tab2">Java </label>
           <input type="radio" name="tab" id="tab3"/>
           <label for="tab3">Python</label>
           <input type="radio" name="tab" id="tab3"/>
           <label for="tab4">C</label>
       
         
           <div class="tab-content-wrapper">
             <div id="tab-content-1" class="tab-content">
           </div>
             <div id="tab-content-2" class="tab-content">
                 </div>
             <div id="tab-content-3" class="tab-content"> 
          </div>
          <div id="tab-content-4" class="tab-content">
              </div>
            </div>
         </div>
         <br /> <br /> <br /> <br /> <br />
               </div>
    )
}

export default Dsw16
